import get from 'lodash/get';

const legalForms = {
    ei: 'EI',
    eirl: 'EIRL',
    eurl: 'EURL',
    sa: 'SA',
    sarl: 'SARL',
    sas: 'SAS',
    sasu: 'SASU',
    sccv: 'SCCV',
    snc: 'SNC',
    other: 'Autre',
};

function formatLegalForm(value: string) {
    return get(legalForms, value, value);
}

export { legalForms, formatLegalForm };
